import { getEventLogs, setEventLogFilters } from '@state/reducers/eventLogReducer'
import { DataGridPro, GridColumns } from '@mui/x-data-grid-pro'
import { EventLogDto } from '@services/dtos'
import { useEffect, useMemo } from 'react'
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { Container } from '@mui/material'
import moment from 'moment'
import { ConfigurationEventLabels } from '@utils/constants'

type Props = {
  entityId: string
}
export default function EventLogsTable({ entityId }: Props) {
  const dispatch = useAppDispatch()
  const { items, loading } = useAppSelector((state) => state.eventLog)
  
  useEffect(() => {
    dispatch(setEventLogFilters({ entityId }))
    dispatch(getEventLogs())
    return () => {
      dispatch(setEventLogFilters({ entityId: undefined }))
    }
  }, [entityId])

  const columns: GridColumns<EventLogDto> = useMemo(
    () => [
      { field: 'createdAt', headerName: 'Date', width: 140, valueFormatter: ({ value }) => moment(value).format('DD/MM/YYYY HH:mm') },
      { field: 'event', headerName: 'Action', width: 100, valueFormatter: ({ value }) => ConfigurationEventLabels[value] },
      {
        field: 'createdBy',
        headerName: 'Par',
        width: 150,
        valueFormatter: ({ value }) => `${value.firstName} ${value.lastName}`,
      },
      {
        field: 'data',
        headerName: 'Données',
        width: 2000,
        valueFormatter: ({ value }) => JSON.stringify({ ...value, id: undefined }).replaceAll('"', '').replaceAll('{', '').replaceAll('}', '').replaceAll(',', ', '),
      },
    ],
    [],
  )

  return (
    <Container
      maxWidth={false}
      sx={{
        height: '100%',
        p: '0 30px',
      }}>
      <DataGridPro
        density="standard"
        pagination
        pageSize={20}
        rowsPerPageOptions={[20]}
        paginationMode="server"
        sx={{
          backgroundColor: 'white',
          borderRadius: '15px 15px 25px 25px',
        }}
        columns={columns}
        rows={items.datas}
        rowCount={items.totalCount}
        loading={loading}
        disableSelectionOnClick
        disableMultipleSelection
      />
    </Container>
  )
}
